import "./Navbar.scss";
import { useState } from "react";
import logo from "../../Assets/cgb-logo.png";
import { NavHashLink } from "react-router-hash-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6285716429078&text=Halo+Wely,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Citra%20Garden%20Bintaro?%20https://www.marketingciputrabintaro.com/&type=phone_number&app_absent=0",
      "_blank"
    );
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <img src={logo} alt="Logo CitraGarden Bintaro" />
        </a>
        <ul className={isMenuOpen ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <NavHashLink smooth to="/#about" className="nav-links">
              About Us
            </NavHashLink>
          </li>
          <li className="nav-item">
            <NavHashLink smooth to="/#promo" className="nav-links">
              Promo
            </NavHashLink>
          </li>
          <li className="nav-item">
            <NavHashLink smooth to="/#rumah" className="nav-links">
              Rumah
            </NavHashLink>
          </li>
          <li className="nav-item">
            <NavHashLink smooth to="/#fasilitas" className="nav-links">
              Facilities
            </NavHashLink>
          </li>
          <li className="nav-item">
            <NavHashLink smooth to="/#surrounding" className="nav-links">
              Surrounding Area
            </NavHashLink>
          </li>
        </ul>
        <div className="menu-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </div>
        <button onClick={waOpen} className="btn-navbar">
          Hubungi Kami
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
